// src/vocabulary/C1/unit3/questions.js

const questions = [
  // 🟢 Meaning & understanding
  {
    id: 1,
    type: "choice",
    question: "What does 'privacy' mainly refer to?",
    options: [
      "Working faster",
      "Keeping personal information safe",
      "Using social media"
    ],
    correctAnswer: "Keeping personal information safe"
  },

  {
    id: 2,
    type: "choice",
    question: "Which word relates to machines doing human work?",
    options: [
      "Innovation",
      "Automation",
      "Efficiency"
    ],
    correctAnswer: "Automation"
  },

  // 🟡 Usage & nuance
  {
    id: 3,
    type: "choice",
    question: "Choose the most accurate sentence:",
    options: [
      "Technology has increased efficiency in many fields.",
      "Technology increased many efficiency.",
      "Technology efficiency many increased."
    ],
    correctAnswer: "Technology has increased efficiency in many fields."
  },

  {
    id: 4,
    type: "choice",
    question: "Which sentence expresses a balanced opinion?",
    options: [
      "Technology is perfect.",
      "Technology is dangerous.",
      "Technology offers benefits but also risks."
    ],
    correctAnswer: "Technology offers benefits but also risks."
  },

  // 🔵 Critical thinking
  {
    id: 5,
    type: "choice",
    question: "Why can digital dependence be a problem?",
    options: [
      "Because it improves innovation",
      "Because it may affect real-life interaction",
      "Because it saves time"
    ],
    correctAnswer: "Because it may affect real-life interaction"
  },

  {
    id: 6,
    type: "choice",
    question: "Which sentence best reflects a C1-level discussion?",
    options: [
      "I like technology.",
      "Technology changes how people communicate.",
      "Technology can reshape social behavior over time."
    ],
    correctAnswer: "Technology can reshape social behavior over time."
  }
];

export default questions;


